/**
 * Countdown component initialization
 * Automatically initializes all countdown clocks on the page
 */
import {CountdownClock} from '../modules/countdownClock.js';

/**
 * Initialize all countdown components on the page
 */
function initializeCountdowns() {
    const countdowns = document.querySelectorAll('.countdown[data-close-timestamp]');
    
    countdowns.forEach((countdown) => {
        const clock = countdown.querySelector('.clock');
        const endTimestamp = countdown.dataset.closeTimestamp;
        
        if (clock && endTimestamp) {
            new CountdownClock(clock, endTimestamp, () => window.location.reload());
        }
    });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCountdowns);
} else {
    initializeCountdowns();
}
